<h1 mat-dialog-title>
    Atualização de Km
</h1>

<button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
    <app-form [campos]="camposAtualizacaoKm" appearance="outline" #formAtualizacaoKm></app-form>
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button type="submit" mat-flat-button
        [disabled]="!formAtualizacaoKm.isValid"
        (click)="putAtualizarKm()">
        Salvar
    </button>

    <button type="button" mat-flat-button (click)="close()">
        Cancelar
    </button>
</div>